<script setup lang="ts">
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'

defineProps<{
	show: boolean
	title: string
}>()

const emits = defineEmits(['close'])
</script>

<template>
	<TransitionRoot appear :show="show" as="template">
		<Dialog as="div" class="relative z-50" @close="emits('close')">
			<TransitionChild
				as="template"
				enter="duration-300 ease-out"
				enter-from="opacity-0"
				enter-to="opacity-100"
				leave="duration-200 ease-in"
				leave-from="opacity-100"
				leave-to="opacity-0">
				<div class="fixed inset-0 bg-slate-900 bg-opacity-25" />
			</TransitionChild>

			<div class="fixed inset-0 overflow-y-auto">
				<div class="flex min-h-full items-center justify-center p-4 text-center">
					<TransitionChild
						as="template"
						enter="duration-300 ease-out"
						enter-from="opacity-0 scale-95"
						enter-to="opacity-100 scale-100"
						leave="duration-200 ease-in"
						leave-from="opacity-100 scale-100"
						leave-to="opacity-0 scale-95">
						<DialogPanel class="w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white p-4 lg:p-6 text-left align-middle shadow-xl transition-all">
							<h3 class="text-lg font-medium leading-6 text-gray-900 flex justify-between items-center">
								{{ title }}
								<button
									type="button"
									class="text-primary hover:text-primary-dark cursor-pointer !outline-none"
									@click="emits('close')">
									Close
								</button>
							</h3>
							<div class="mt-4">
								<slot />
							</div>
						</DialogPanel>
					</TransitionChild>
				</div>
			</div>
		</Dialog>
	</TransitionRoot>
</template>
